export const validateJobPostingForm = (t: any, values: any) => {
  const errors: any = {};

  const localisedFieldName = (fieldName: string) => {
    return t('companyJobPostings.newJobDialog.formLabels.' + fieldName);
  };

  if (!values.title) {
    errors.title = t('shared.formValidation.required', {fieldName: localisedFieldName('title')});
  }

  if (!values.departments) {
    errors.department = t('shared.formValidation.required', {fieldName: localisedFieldName('department')});
  }

  if (values.locations.length === 0 && !values.remoteHiring) {
    errors.locations = t('shared.formValidation.required', {fieldName: localisedFieldName('locations')});
  }

  if (values.salary.min && values.salary.max && Number(values.salary.min) >= Number(values.salary.max)) {
    errors.salary = t('companyJobPostings.newJobDialog.formValidations.minSalaryNotGreaterThanMax');
  }

  if (!values.workMode) {
    errors.workMode = t('shared.formValidation.required', {fieldName: localisedFieldName('workMode')});
  }

  if (!values.employmentType?.length) {
    errors.employmentType = t('shared.formValidation.required', {fieldName: localisedFieldName('employmentType')});
  }

  if (!values.degree) {
    errors.degree = t('shared.formValidation.required', {fieldName: localisedFieldName('degree')});
  }

  if (
    (values.experience.yearsOfExperience && values.experience.yearsOfExperience < 0) ||
    (values.experience.yearsOfLeadership && values.experience.yearsOfLeadership < 0)
  ) {
    errors.experience = t('companyJobPostings.newJobDialog.formValidations.valueCannotBeNegative');
  }

  if (values.experience.yearsOfExperience < values.experience.yearsOfLeadership) {
    errors.experience = t('companyJobPostings.newJobDialog.formValidations.yearsOfLeadershipNotGreaterThanExperience');
  }

  if (values.languageSkills.length === 0) {
    errors.languageSkills = t('shared.formValidation.required', {fieldName: localisedFieldName('languages')});
  }

  if (!values.responsibilities) {
    errors.responsibilities = t('shared.formValidation.required', {fieldName: localisedFieldName('responsibilities')});
  }

  if (!values.requirements) {
    errors.requirements = t('shared.formValidation.required', {fieldName: localisedFieldName('requirements')});
  }

  if (values.skills.length === 0) {
    errors.skills = t('shared.formValidation.required', {fieldName: localisedFieldName('skills')});
  }

  return errors;
};
